import styled, { css } from "styled-components";

const ArrowSpanStyled = styled.span`
  ${props => {
    const rotateDeg = {
      up: css`
        transform: translateY(-50%) rotate(-135deg);
        margin-top: 7px;
      `,
      down: css`
        transform: translateY(-50%) rotate(45deg);
      `,
      right: css`
        transform: translateY(-50%) rotate(-45deg);
        margin-top: 5px;
      `,
      left: css`
        transform: translateY(-50%) rotate(135deg);
        margin-top: 5px;
      `
    };
    return rotateDeg[props.direction];
  }}
  border-color: ${props => props.color ?? "white"};
  border-style: solid;
  border-width: 0 2px 2px 0;
  width: 7px;
  height: 7px;
`;

const ArrowWrapper = styled.div.attrs(() => ({
  className: "uc-arrow-icon"
}))`
  position: relative;
  display: flex;
  margin: 0 5px 0 auto;
  height: inherit;
  justify-content: center;
  align-items: center;
`;

export { ArrowWrapper, ArrowSpanStyled };
